import React from 'react';
import './YesNoToggle.css';

/**
 * Sliding switch for `yesno` fields.
 *
 * Values on the wire are the strings 'Yes' and 'No'. Anything else - null, an
 * unset custom field, a legacy boolean - reads as off, and the first toggle
 * writes a real 'Yes'/'No' so the stored value is normalised on the way out.
 */
const YesNoToggle = ({ value, onChange, disabled = false, label }) => {
  const isYes = value === 'Yes' || value === true || value === 'true';

  const handleToggle = () => {
    if (disabled) return;
    onChange(isYes ? 'No' : 'Yes');
  };

  return (
    <div className="yesno-toggle-container">
      <button
        type="button"
        role="switch"
        aria-checked={isYes}
        aria-label={label}
        className={`yesno-toggle ${isYes ? 'is-yes' : 'is-no'}`}
        disabled={disabled}
        onClick={handleToggle}
      >
        <span className="yesno-toggle-thumb"></span>
      </button>
      <span className="yesno-toggle-text">{isYes ? 'Yes' : 'No'}</span>
    </div>
  );
};

export default YesNoToggle;
